import { humanizeEnum } from '../../utils/format';

const PLAIN_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * A stored calendar date ("2026-08-01", or a timestamp starting with one) as local midnight, so it
 * never shows as the day before in a timezone behind UTC.
 */
export const parsePlainDate = (value) => {
  if (!value) return null;
  const match = PLAIN_DATE.exec(String(value));
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** A stored date as the "YYYY-MM-DD" a date input expects, or '' when there is none. */
export const toDateInputValue = (value) => {
  if (!value) return '';
  const match = PLAIN_DATE.exec(String(value));
  if (match) return match[0];
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

/** Whole days from today to a calendar date: 0 today, negative once it has passed. */
export const daysUntil = (value) => {
  const date = parsePlainDate(value);
  if (!date) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((date.getTime() - today.getTime()) / 86400000);
};

/** "ANNUAL", "YEARLY" and "ANNUALLY" all read as "Annual"; others as "Monthly", "Quarterly". */
export const frequencyLabel = (value) => {
  if (!value) return null;
  const upper = String(value).toUpperCase();
  return ['ANNUAL', 'ANNUALLY', 'YEARLY'].includes(upper) ? 'Annual' : humanizeEnum(value);
};

/** Seats the company has: free plus paid. */
export const seatsOf = (company) => (company?.freeUsers || 0) + (company?.paidUsers || 0);
